module.exports = __webpack_public_path__ + "img/1Q.6053a2a1.jpg";